// extracted by mini-css-extract-plugin
export var footer = "_ot-5";
export var fulfillmentInput = "_ot-0";
export var shipDateInput = "_ot-1";
export var shipmentModal = "_ot-2";
export var shipmentModalContent = "_ot-3";
export var tableContainer = "_ot-4";